import { withMixpanel } from 'components'
import { connect } from 'react-redux'
import { bindActionCreators, compose } from 'redux'
import { formValueSelector, reduxForm } from 'redux-form'
import { _route } from 'routes/config'
import * as PatientActions from '../../store/patients/actions'
import * as UserActions from '../../store/user/actions'
import { AddChild } from './addChild'
import {
  IAddChildReduxDispatchProps,
  IAddChildReduxStateProps,
  IChildDetails
} from './interfaces'

const AddChildContainer = reduxForm({
  form: 'addChild'
})(AddChild)

const selector = formValueSelector('addChild')

const mapStateToProps = (state): IAddChildReduxStateProps => {
  const childDetails: IChildDetails = {
    first_name: (selector(state, 'firstName') || '').trim(),
    dateOfBirth: selector(state, 'dateOfBirth') || '',
    gender: selector(state, 'gender') || ''
  }

  return {
    ...childDetails,
    childDetails,
    user: state.user.data,
    authData: state.user.auth,
    currentPatient: state.patients.currentPatient,
    patients: state.patients.patients,
    plus_user: state.plus_user.isPlusUser
  }
}

const mapDispatchToProps = (dispatch): IAddChildReduxDispatchProps => {
  return {
    PatientsLib: bindActionCreators(PatientActions, dispatch),
    UserLib: bindActionCreators<any, any>(UserActions, dispatch)
  }
}

export default compose(
  withMixpanel,
  connect(mapStateToProps, mapDispatchToProps)
)(AddChildContainer)



// WEBPACK FOOTER //
// ./src/pages/AddChild/index.tsx